import { UpdateUserResponse } from '../../../../../../types/api/endpoints/auth/update.types';
import { AUTH_ENDPOINTS } from '../../../../../../utils/api/endpoints/authEndpoints';
import { ProfileAccountFormSchema } from './ProfileAccountForm.types';

const PREFIX = '[updateUserQuery]';

export const UPDATE_USER_QUERY_KEY = 'UPDATE_USER';

export const updateUserQuery = async (data: ProfileAccountFormSchema) => {
  console.log(PREFIX, `Requesting user account update...`);
  const response = await AUTH_ENDPOINTS.update(data);

  const { ok, data: json } = response;

  if (!ok) {
    const error = response.data;
    console.log(PREFIX, 'An error occurred.', error);
    throw error;
  }

  console.log(PREFIX, `Received user account update response.`);
  return json as UpdateUserResponse;
};
